var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobalIconDarkTheme(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_18330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 9.99935C18.3346 14.6017 14.6037 18.3327 10.0013 18.3327M18.3346 9.99935C18.3346 5.39698 14.6037 1.66602 10.0013 1.66602M18.3346 9.99935H1.66797M10.0013 18.3327C5.39893 18.3327 1.66797 14.6017 1.66797 9.99935M10.0013 18.3327C12.0857 16.0507 13.2703 13.0893 13.3346 9.99935C13.2703 6.90938 12.0857 3.94798 10.0013 1.66602M10.0013 18.3327C7.9169 16.0507 6.73234 13.0893 6.66797 9.99935C6.73234 6.90938 7.9169 3.94798 10.0013 1.66602M1.66797 9.99935C1.66797 5.39698 5.39893 1.66602 10.0013 1.66602",
    stroke: "#E0E1DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_18330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalIconDarkTheme);
export default __webpack_public_path__ + "static/media/global-icon-dark-theme.5e31d6a5ec9bd88d6d4c363932fb3e11.svg";
export { ForwardRef as ReactComponent };